import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useChatContext } from '../../../providers/ChatProvider';
import classNames from 'classnames';

const MessageBubble = ({ message }) => {
  const { sender, message: content, time } = message;

  const renderMessageContent = () => {
    // Convertir <br> a saltos de línea reales para renderizado
    const formattedContent = content.replace(/<br>/g, '\n');
    
    return (
      <div className="message-content">
        {formattedContent.split('\n').map((line, index) => (
          <div key={index}>
            {line}
            {index < formattedContent.split('\n').length - 1 && <br />}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={classNames('chat-message', sender)}>
      <div className={classNames('message-bubble', sender)}>
        {sender === 'assistant' && (
          <div className="message-avatar mb-2">
            <FontAwesomeIcon icon={faRobot} className="me-2" />
            <strong>Galaxy AI</strong>
          </div>
        )}
        
        {sender === 'system' && (
          <div className="message-avatar mb-2">
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            <strong>Sistema</strong>
          </div>
        )}

        {renderMessageContent()}
        
        <div className="message-time">
          {time.hour} - {time.date}
        </div>
      </div>
    </div>
  );
};

const ChatMessages = () => {
  const { messages } = useChatContext();

  return (
    <div className="chat-messages flex-grow-1 overflow-auto p-3" style={{ maxHeight: 'calc(100% - 140px)' }}>
      {messages.map((message) => (
        <MessageBubble key={message.id} message={message} />
      ))}
    </div>
  );
};

export default ChatMessages; 